module.exports = __webpack_public_path__ + "static/media/Piercing-ear-industrial.ccfe280d.png";